import React from "react";
import { Row, Col, Card } from "react-bootstrap";

const formatMoney = (cents, currency = "USD") => {
  const amount = (cents || 0) / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);
};

const StatCard = ({ label, value, hint, accent }) => (
  <Card className="shadow-sm h-100" style={{ border: "none" }}>
    <Card.Body>
      <div
        style={{
          fontSize: "12px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          color: "#777",
          marginBottom: "8px",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: "26px",
          fontWeight: 700,
          color: accent || "#2c3e50",
        }}
      >
        {value}
      </div>
      {hint && (
        <div style={{ fontSize: "12px", color: "#888", marginTop: "6px" }}>
          {hint}
        </div>
      )}
    </Card.Body>
  </Card>
);

const EarningsOverview = ({ summary }) => {
  if (!summary) return null;

  return (
    <Row className="g-3">
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="Lifetime Earned"
          value={formatMoney(summary.lifetime_earned_cents)}
          hint="Pending + paid commissions"
          accent="darkgreen"
        />
      </Col>
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="This Month"
          value={formatMoney(summary.this_month_cents)}
          hint="Conversions this calendar month"
        />
      </Col>
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="Pending Payout"
          value={formatMoney(summary.pending_payout_cents)}
          hint="Cleared, awaiting next payout cycle"
          accent="#b86e00"
        />
      </Col>
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="Paid Out"
          value={formatMoney(summary.paid_cents)}
          hint="Lifetime payouts to your account"
        />
      </Col>
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="Trials Started"
          value={summary.trials_started || 0}
          hint="Total trials your code triggered"
        />
      </Col>
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="Paid Conversions"
          value={summary.paid_conversions || 0}
          hint="First paid subscriptions only"
        />
      </Col>
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="Trial Pending"
          value={formatMoney(summary.trial_pending_cents)}
          hint="Will clear after 3-day trial converts"
          accent="#6c757d"
        />
      </Col>
      <Col xs={12} sm={6} lg={3}>
        <StatCard
          label="Voided"
          value={summary.voided_count || 0}
          hint="Cancellations / refunds"
          accent="#a94442"
        />
      </Col>
    </Row>
  );
};

export default EarningsOverview;
